let pending: Promise<void> | null = null;

export function ensureYouTubeApi(): Promise<void> {
  if (window.YT?.Player) return Promise.resolve();
  if (pending) return pending;

  pending = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.dataset.youtubeApi = 'true';
    script.src = 'https://www.youtube.com/iframe_api';
    const previous = window.onYouTubeIframeAPIReady;
    const finish = (error?: Error) => {
      window.clearTimeout(timeout);
      script.onerror = null;
      if (window.onYouTubeIframeAPIReady === ready) {
        window.onYouTubeIframeAPIReady = previous;
      }
      if (error) {
        script.remove();
        reject(error);
      } else {
        resolve();
      }
    };
    const ready = () => {
      if (!window.YT?.Player) return;
      finish();
      previous?.();
    };
    const timeout = window.setTimeout(() => finish(new Error('YouTube loading timed out.')), 15_000);
    window.onYouTubeIframeAPIReady = ready;
    script.onerror = () => finish(new Error('YouTube could not be loaded.'));
    document.head.append(script);
  }).finally(() => {
    pending = null;
  });
  return pending;
}
